// Configuração do cardápio digital (app cliente-final, público por slug).
//
// SEM switch mock/real: este app SEMPRE fala com o backend real (contrato
// GET /api/v1/public/cardapio/{slug}). A única configuração é a base da API.

// Lidas em build/dev pelo Vite (import.meta.env — ver src/vite-env.d.ts).
const RAW_BASE = String(import.meta.env.VITE_API_BASE ?? '').trim();

// Base da API real (ex.: https://api.vittogestao.com.br). Sem barra no fim.
// Vazio = requisições relativas à mesma origem do site (útil atrás de proxy).
export const API_BASE: string = RAW_BASE.replace(/\/+$/, '');

export function apiBase(): string {
  return API_BASE;
}
